import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import resendImg from "../../assets/img/resend-email.png"
const ActionResend = ({to,onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
     <img src={resendImg} style={{width:20}} /> {children}
    </Link>
  );
};

ActionResend.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionResend.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionResend;
